import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './main.component.html'
})
export class MainComponent {
  statusBar = false;

  constructor() {
  }

  /**
   * Ocultar menu.
   */
  closeMenu() {
    this.statusBar = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/base-component/main.component.ts